import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import GameTypeProp from '../../../challenges/propTypes/gameTypeProp';
import translate from '../../../../commonComponents/translate';
import ServerSideCarousel from '../../../../commonComponents/carousel/ServerSideCarousel';
import ChallengeCarouselItem from './ChallengeCarouselItem';
import ChallengeFilters from './ChallengeFilters';
import GameCategoriesProp from '../../../challenges/propTypes/gameCategoriesProp';
import Notifications from '../../../../services/notifications';

const getChallenges = async () => {
  try {
    const { data } = await axios.get('/api/game/list?index=0&offset=1', {
      params: { status: ['unstarted', 'ongoing', 'permanent'] },
      headers: {
        'X-Gamification-API': 'Games',
      },
    });

    return data.total > 0;
  } catch (e) {
    Notifications.showErrorFromRequest('');
    return false;
  }
};

function ChallengeSection({ t, gameTypes, gameCategories }) {
  const [showSection, setShowSection] = useState(false);
  const [myType, setMyType] = useState('');
  const [category, setCategory] = useState('');
  const [search, setSearch] = useState('');

  const url = `/table/game/list?gameType=${myType}&category=${category}&search=${search}`;
  const carouselItems = items => {
    const sortedItems = items.sort((a, b) => a.updatedAt - b.updatedAt);
    return sortedItems.map(game => (
      <ChallengeCarouselItem key={game._id} game={game} />
    ));
  };

  useEffect(() => {
    getChallenges().then(r => setShowSection(r));
  }, []);
  return (
    showSection && (
      <div className="row">
        <div className="col-xl-12 col-12">
          <div className="m-portlet m-portlet--rounded m-portlet--rounded-force m-portlet--full-height">
            <div className="m-portlet__head remove-border-challenges row">
              <div className="m-portlet__head-caption col-12 col-lg-3">
                <div className="m-portlet__head-title">
                  <h3 className="m-portlet__head-text">
                    {t('inbox_myChallenges')}
                  </h3>
                </div>
              </div>
              <ChallengeFilters
                id="myGamesFilter"
                gameTypes={gameTypes}
                onChange={setMyType}
                onChangeCategory={setCategory}
                onChangeSearch={setSearch}
                gameCategories={gameCategories}
              />
            </div>
            <div className="m-portlet__body challenge-container-inbox row">
              <ServerSideCarousel
                id="my-inboxChallenges-carousel"
                fetchUrl={url}
                defaultFetchError="error_fetchMyChallenges"
                fetchHeaders={{
                  'Accept-Version': '1.0.0',
                  'X-Gamification-API': 'Games',
                  'Content-Type': 'application/json',
                }}
                fetchQuery={{
                  status: ['unstarted', 'ongoing', 'permanent'],
                }}
              >
                {items => carouselItems(items)}
              </ServerSideCarousel>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

ChallengeSection.propTypes = {
  t: PropTypes.func.isRequired,
  gameTypes: PropTypes.arrayOf(PropTypes.shape(GameTypeProp.propTypes))
    .isRequired,
  gameCategories: PropTypes.arrayOf(
    PropTypes.shape(GameCategoriesProp.propType),
  ).isRequired,
};

export default translate(ChallengeSection);
